module.exports = __webpack_public_path__ + "static/media/image_11.142ffd02.png";